// export const BaseUrl = 'https://liss.vercel.app/'
// export const BaseUrl = 'https://liss-center-2.herokuapp.com/'
// export const BaseUrl = 'http://localhost:4000/'
export const BaseUrl = 'https://confidences-le-salon.herokuapp.com/'

export const token = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };
